import React from 'react'
import Container from '@material-ui/core/Container'
import styleClasses from '../components/common/common.module.scss'
import BuildingDetail from '../components/buildings/BuildingDetail'

export default function BuildingDetailPage() {
  return (
    <main className={styleClasses.content}>
      <Container maxWidth="lg" className={styleClasses.container}>
        <BuildingDetail />
      </Container>
    </main>
  )
}
